import React, { ReactNode } from 'react';
import { Inbox } from 'lucide-react';

interface AdminEmptyStateProps {
  title?: string;
  description?: string;
  icon?: ReactNode;
  action?: ReactNode;
}

/**
 * AdminEmptyState - Empty state component for admin lists
 * Shows when no data is available
 */
export const AdminEmptyState: React.FC<AdminEmptyStateProps> = ({
  title = 'Nenhum item encontrado',
  description,
  icon,
  action,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-6 text-center">
      <div className="text-[#888888] mb-4">
        {icon || <Inbox className="w-12 h-12" />}
      </div>
      <h3 className="text-lg font-medium text-white mb-2">
        {title}
      </h3>
      {description && (
        <p className="text-[#888888] text-sm max-w-md mb-4">
          {description}
        </p>
      )}
      {action && (
        <div className="mt-2">
          {action}
        </div>
      )}
    </div>
  );
};

export default AdminEmptyState;
